exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".loader[data-v-7130cc8d]{margin:106px 0}", "", {"version":3,"sources":["C:/Users/jusma/Projects/lowco.tv/src/components/global/Loading.vue"],"names":[],"mappings":"AACA,yBACE,cAAgB,CACjB","file":"Loading.vue","sourcesContent":["\n.loader[data-v-7130cc8d] {\n  margin: 106px 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7130cc8d","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/global/Loading.vue
// module id = 987
// module chunks = 0 1 2 3 6